import { render, staticRenderFns } from "./PeoClients.vue?vue&type=template&id=0abe90c4&scoped=true&"
import script from "./PeoClients.vue?vue&type=script&lang=js&"
export * from "./PeoClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abe90c4",
  null
  
)

export default component.exports